import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import React from 'react'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearanceNew from '../options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from '../options/HtmlAttrId'
import Border from '../styles/Border'
import ShadowStyle from '../styles/ShadowStyle'

function BlogPostImageSettings({ entity }: { entity: BlogPostImageInterface }) {
  const updateProp = useUpdateProp(entity)

  const { isMobile } = useDeviceModeContext()

  return (
    <>
      <Border
        update={updateProp('border')}
        mobileUpdate={updateProp('mobileBorder')}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
      />
      <ShadowStyle
        shadow={entity.boxShadow}
        mobileShadow={entity.mobileBoxShadow}
        update={updateProp('boxShadow')}
        mobileUpdate={updateProp('mobileBoxShadow')}
      />
      <ColorPickerControl
        isGradientAvailable
        label="background color"
        color={entity.background}
        mobileColor={entity.mobileBackground || entity.background}
        update={updateProp('background')}
        mobileUpdate={updateProp('mobileBackground')}
        isClearable
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default BlogPostImageSettings
